import { useContext } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { AuthContext } from "../contexts/AuthContext";
import { PageContext, PAGE_ACCOUNT, PAGE_ANNOUNCE, PAGE_DATABASE, PAGE_FAQ, PAGE_LOCK, PAGE_LOGIN, PAGE_MAOLAM_APPROVE, PAGE_MAOLAM_REGISTER, PAGE_OWN, PAGE_REGISTER, PAGE_SUMMARY } from "../contexts/PageContext";
import { SignOut } from "../databases/auth";
import { 
    ICON_HEADER_BARS, ICON_HEADER_DATABASE, ICON_HEADER_FAQ, ICON_HEADER_FLIGHT, ICON_HEADER_GEAR, ICON_HEADER_HOME, ICON_HEADER_LOCK, ICON_HEADER_REGISTER, ICON_HEADER_TABLE, ICON_HEADER_USER, ICON_HEADER_SIGNOUT, 
    //ICON_HEADER_SM_BARS, ICON_HEADER_SM_DATABASE, ICON_HEADER_SM_FAQ, ICON_HEADER_SM_FLIGHT, ICON_HEADER_SM_GEAR, ICON_HEADER_SM_HOME, ICON_HEADER_SM_LOCK, ICON_HEADER_SM_REGISTER, ICON_HEADER_SM_TABLE, ICON_HEADER_SM_USER,  
} from "./icons";



const Header = () => {

    const { isLogin, owndata, userRole } = useContext(AuthContext)
    const { setPage } = useContext(PageContext);

    return (
        <div className="container-fluid fixed-header" style={{background: 'white', height: 'fit-content', boxShadow: '0 3px 6px 0 #f0f0f0', marginBottom: '20px', paddingBlock: '5px', alignItems: 'center'}}>
            <Row bsPrefix="row align-items-center">
                <Col bsPrefix="col-auto" style={{width : '60px'}}>
                    <img src="./images/DMK_LOGO.png" alt="" height='60px' style={{marginTop: '-5px', marginBottom : '-5px'}} ></img>
                </Col>
                <Col bsPrefix="col-auto" style={{width : '200px', paddingLeft: '20px'}}>
                    <span className="h4">ระบบแดนมังกร</span>
                </Col>
                {/*<Col bsPrefix="col sm-auto d-none d-sm-inline" />*/}
                <Col bsPrefix="col sm-auto d-sm-inline d-none text-end" >
                    {(owndata.nameEN ? `สวัสดี คุณ ${owndata.nameEN.split(' ')[0]}` : '')}
                </Col>
                <Col xs='12' sm='auto'>
                    <div style={{textAlign: 'right'}}>
                        <Button variant='round-light' hidden={!isLogin || userRole < 2} onClick={() => setPage(PAGE_MAOLAM_APPROVE)}>
                            {ICON_HEADER_FLIGHT}
                        </Button>
                        <Button variant='round-light' hidden={!isLogin || userRole < 2} onClick={() => setPage(PAGE_SUMMARY)}>
                            {ICON_HEADER_TABLE}
                        </Button>
                        <Button variant='round-light' hidden={!isLogin || !userRole} onClick={() => setPage(PAGE_LOCK)}>
                            {ICON_HEADER_LOCK}
                        </Button>
                        <Button variant='round-light' hidden={!isLogin || !userRole} onClick={() => setPage(PAGE_DATABASE)}>
                            {ICON_HEADER_DATABASE}
                        </Button>
                        <Button variant='round-success' hidden={!isLogin || userRole < 2} onClick={() => setPage(PAGE_MAOLAM_REGISTER)}>
                            {ICON_HEADER_FLIGHT}
                        </Button>
                        <Button variant='round-light' hidden={!isLogin} onClick={() => setPage(PAGE_ANNOUNCE)}>
                            {ICON_HEADER_BARS}
                        </Button>
                        <Button variant='round-light' hidden={!isLogin} onClick={() => setPage(PAGE_OWN)}>
                            {ICON_HEADER_USER}
                        </Button>
                        <Button variant='round-light' onClick={() => setPage(PAGE_FAQ)}>
                            {ICON_HEADER_FAQ}
                        </Button>
                        <Button variant='round-light' hidden={!isLogin} onClick={() => setPage(PAGE_ACCOUNT)}>
                            {ICON_HEADER_GEAR}
                        </Button>
                        <Button variant='round-danger' hidden={!isLogin} onClick={() => SignOut()}>
                            {ICON_HEADER_SIGNOUT}
                        </Button>
                        <Button variant='round-light' hidden={isLogin} onClick={() => setPage(PAGE_REGISTER)}>
                            {ICON_HEADER_REGISTER}
                        </Button>
                        <Button variant='round-light' hidden={isLogin} onClick={() => setPage(PAGE_LOGIN)}>
                            {ICON_HEADER_HOME}
                        </Button>
                        <a href="https://tcsa.or.th/" style={{paddingLeft : '20px'}} hidden={isLogin} >
                            <span className="d-none d-sm-inline">สมาคมนักเรียนไทย-จีน (tcsa.or.th)</span>
                            <span className="d-sm-none">สมาคม</span>
                        </a>
                    </div>
                </Col>
            </Row>
            {/*<div className="overflow-auto" style={{fontSize : '14px'}}>
                <Row bsPrefix="row d-lg-none" hidden={isLogin} style={{width : 'max-content'}}>
                    <HeaderButton thisPage={PAGE_LOGIN}>{ICON_HEADER_SM_HOME} เข้าสู่ระบบ</HeaderButton>
                    <HeaderButton thisPage={PAGE_REGISTER}>{ICON_HEADER_SM_REGISTER} สร้างบัญชีใหม่</HeaderButton>
                    <HeaderButton thisPage={PAGE_FAQ}>{ICON_HEADER_SM_FAQ} คำถามที่พบบ่อย</HeaderButton>
                </Row>
                <Row bsPrefix="row d-lg-none" hidden={!isLogin || !userRole} style={{width : 'max-content'}}>
                    {userRole >= 2 ? <>
                        <HeaderButton thisPage={PAGE_DATABASE}>{ICON_HEADER_SM_DATABASE} ฐานข้อมูล</HeaderButton>
                        <HeaderButton thisPage={PAGE_LOCK}>{ICON_HEADER_SM_LOCK} เปิด/ปิดการแก้ไข</HeaderButton>
                        <HeaderButton thisPage={PAGE_SUMMARY}>{ICON_HEADER_SM_TABLE} ดาวน์โหลด</HeaderButton>
                        <HeaderButton thisPage={PAGE_MAOLAM_APPROVE}>{ICON_HEADER_SM_FLIGHT} ตรวจสอบเหมาลำ</HeaderButton>
                        <HeaderButton thisPage={PAGE_MAOLAM_REGISTER}>{ICON_HEADER_SM_FLIGHT} ลงทะเบียนเหมาลำ</HeaderButton>
                    </> : <>
                        <HeaderButton thisPage={PAGE_DATABASE}>{ICON_HEADER_SM_DATABASE} ฐานข้อมูล</HeaderButton>
                        <HeaderButton thisPage={PAGE_LOCK}>{ICON_HEADER_SM_LOCK} เปิด/ปิดการแก้ไข</HeaderButton>
                    </>}
                    
                    </Row>
                <Row bsPrefix="row d-lg-none" hidden={!isLogin} style={{width : 'max-content'}}>
                    <HeaderButton thisPage={PAGE_OWN}>{ICON_HEADER_SM_USER} ข้อมูลส่วนตัว</HeaderButton>
                    <HeaderButton thisPage={PAGE_ANNOUNCE}>{ICON_HEADER_SM_BARS} ประกาศ</HeaderButton>
                    <HeaderButton thisPage={PAGE_FAQ}>{ICON_HEADER_SM_FAQ} คำถามที่พบบ่อย</HeaderButton>
                    <HeaderButton thisPage={PAGE_ACCOUNT}>{ICON_HEADER_SM_GEAR} บัญชี</HeaderButton>
                </Row>
            </div>*/}
        </div>
    )
}


/*const HeaderButton = props => {
    const { children, thisPage } = props
    const { page, setPage } = useContext(PageContext);
    return (
        <Col 
            bsPrefix="col-auto" onClick={() => setPage(thisPage)} 
            style={{
                borderBottomWidth : '2px', borderColor : 'black', paddingBottom : '5px', 
                borderBottomStyle : thisPage === page ? 'solid' : 'none',
                color : thisPage === page ? 'black' : '#bfbfbf',
            }}>
            {children}
        </Col>
    )
}*/


export default Header;